var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{attrs:{"id":"loader"}},[_c('div',{staticClass:"content"},[_c('DotLoader'),_c('span',{staticClass:"info"},[_vm._t("default")],2)],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }